import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import LeaseManagementList from './components/LeaseManagementList';

const { Cell } = ResponsiveGrid;

const MachineInspect = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="租賃停車位"
        breadcrumbs={[
          {
            name: '租賃管理',
          },
          {
            name: '租賃停車位',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <LeaseManagementList />
    </Cell>
  </ResponsiveGrid>
);

export default MachineInspect;
